module.exports = __webpack_public_path__ + "img/spth.73052010.png";